import { Component, ReactNode } from 'react';
import Sentry from '../../services/sentry';
import MText from './MText';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  location: string;
  context?: any;
  fallback?: ReactNode;
  children: ReactNode;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: any) {
    const { location, context } = this.props;
    Sentry.captureException(error, {
      extra: {
        context,
        info,
      },
      tags: {
        type: 'COMPONENT_ERROR_BOUNDARY',
        location,
      },
    });
  }

  render() {
    const { fallback, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        fallback || <MText>Sorry, it looks like there was an error!</MText>
      );
    }

    return children;
  }
}
